// Explicit .ts extensions: this module is unit-tested by Node directly.
import { nmFrom } from './stations.ts';
import { STATIONS } from './stations.ts';

/**
 * Tide stations, taken from the set the San Francisco Bar Pilots publish:
 * https://sfbarpilots.com/partners/noaa-tide-current-links/
 *
 * Range varies far more across the Bay than people expect — Redwood City swings
 * 8.2 ft on the same day Rio Vista moves 4.0 — which is the argument for showing
 * them individually rather than quoting the Golden Gate everywhere.
 */
export interface TideStation {
  id: string;
  name: string;
  lat: number;
  lon: number;
}

export const TIDE_STATIONS: TideStation[] = [
  { id: '9414290', name: 'San Francisco (Golden Gate)', lat: 37.8063, lon: -122.4659 },
  { id: '9414358', name: 'Hunters Point', lat: 37.73, lon: -122.357 },
  { id: '9414458', name: 'San Mateo Bridge', lat: 37.58, lon: -122.253 },
  { id: '9414523', name: 'Redwood City Wharf 5', lat: 37.5068, lon: -122.2119 },
  { id: '9414750', name: 'Alameda', lat: 37.772, lon: -122.3003 },
  { id: '9414764', name: 'Oakland Inner Harbor', lat: 37.795, lon: -122.282 },
  { id: '9414863', name: 'Richmond (Chevron Pier)', lat: 37.9283, lon: -122.4 },
  { id: '9415056', name: 'Pinole Point', lat: 38.015, lon: -122.363 },
  { id: '9415102', name: 'Martinez-Amorco Pier', lat: 38.0346, lon: -122.1252 },
  { id: '9415143', name: 'Crockett', lat: 38.0583, lon: -122.223 },
  { id: '9415218', name: 'Mare Island', lat: 38.07, lon: -122.25 },
  { id: '9415112', name: 'Mallard Island Ferry Wharf', lat: 38.0433, lon: -121.918 },
  { id: '9415144', name: 'Port Chicago', lat: 38.056, lon: -122.0395 },
  { id: '9415064', name: 'Antioch', lat: 38.02, lon: -121.815 },
  { id: '9415316', name: 'Rio Vista', lat: 38.145, lon: -121.692 },
];

/** Closer than this and two markers would sit on top of each other. */
const COLOCATED_NM = 0.3;

/**
 * Six of these share a pier with a wind station. Their markers are nudged clear
 * so both stay visible and clickable rather than one burying the other.
 */
export function isColocatedWithWind(t: TideStation): boolean {
  return STATIONS.some((s) => nmFrom(s.lat, s.lon, { lat: t.lat, lon: t.lon }) < COLOCATED_NM);
}

export function tideStationById(id: string): TideStation | undefined {
  return TIDE_STATIONS.find((t) => t.id === id);
}
